import React, { Component } from "react";

import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutTheme,
  changeLayoutWidth,
  verify_admin
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";
import withRouter from "../Common/withRouter";
import ToggleMenu from "./ToggleMenu";
import LoadingDialog from "../Common/LoadingDialog";
import Notification from "../Common/Notification";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      pathName: this.props.router.location.pathname,
      width: window.innerWidth,
      notification: {
        open: false,
        msg: "",
        type: "success",
      }
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader === true) {
        document.getElementById('preloader').style.display = "block";
        document.getElementById('status').style.display = "block";

        setTimeout(function () {

          document.getElementById('preloader').style.display = "none";
          document.getElementById('status').style.display = "none";

        }, 2500);
      }
      else {
        document.getElementById('preloader').style.display = "none";
        document.getElementById('status').style.display = "none";
      }

      if (prevProps.router.location.pathname !== this.props.router.location.pathname) {
        // Scroll Top to 0
        window.scrollTo(0, 0);

        let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

        currentage = currentage.replaceAll("-", " ");
        currentage = currentage.split('/')[0];

        document.title =
          currentage + " | BESarawak";

        if (this.props.leftSideBarTheme) {
          this.props.changeSidebarTheme(this.props.leftSideBarTheme);
        }

        if (this.props.layoutWidth) {
          this.props.changeLayoutWidth(this.props.layoutWidth);
        }

        if (this.props.leftSideBarType) {
          this.props.changeSidebarType(this.props.leftSideBarType);
        }
        if (this.props.topbarTheme) {
          this.props.changeTopbarTheme(this.props.topbarTheme);
        }
        if (this.props.theme) {
          this.props.changeLayoutTheme(this.props.theme);
        }

        if (this.props.showRightSidebar) {
          this.toggleRightSidebar();
        }
      }

      if (prevProps.error !== this.props.error) {
        if (this.props.error?.code === "network_error") {
          this.setState({
            notification: {
              open: true,
              msg: "Network response error, please try again later",
              type: "error"
            }
          });
        }
      }
    }
  }

  componentDidMount() {
    console.log("Layout Mounted")
    window.addEventListener("resize", this.handleResize);

    // Scroll Top to 0
    window.scrollTo(0, 0);

    if (!this.props.router.location.pathname.includes("/issue-report") && !this.props.router.location.pathname.includes("/complete-task")) {
      console.log("calll verify admin")
      this.props.verify_admin();
    }

    let currentage = this.capitalizeFirstLetter(this.props.router.location.pathname);

    currentage = currentage.replaceAll("-", " ");
    currentage = currentage.split('/')[0];

    document.title = currentage + " | BESarawak";

    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
    if (this.props.theme) {
      this.props.changeLayoutTheme(this.props.theme);
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
  }

  UNSAFE_componentDidUpdate(prevProps) {
    if (this.props.router.location.pathname !== this.state.pathName) {
      this.setState({ pathName: this.props.router.location.pathname })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }

    this.setState({ width: window.innerWidth });
  };

  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", false);
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", false);
    }
  };

  render() {
    console.log("isMobile", this.state.isMobile, this.state.width)
    return (
      <React.Fragment>
        <Notification notification={this.state.notification} setNotification={(e) => this.setState({ notification: e })} />
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>

        {
          this.props.verifyAdmin?.user?.code || this.props.router.location.pathname.includes("/issue-report") || this.props.router.location.pathname.includes("/complete-task") ?
            <>
              <div id="layout-wrapper">
                {
                  this.props.router.location.pathname.includes("/issue-report") || this.props.router.location.pathname.includes("/complete-task") ? null :
                    <>
                      {/* <ToggleMenu toggleMenuCallback={this.toggleMenuCallback} toggleRightSidebar={this.toggleRightSidebar} /> */}
                      <Sidebar
                        theme={this.props.leftSideBarTheme}
                        type={this.props.leftSideBarType}
                        toggleMenuCallback={this.toggleMenuCallback}
                        toggleRightSidebar={this.toggleRightSidebar}
                        isMobile={this.state.isMobile}
                      />
                    </>
                }

                <div className={this.props.router.location.pathname.includes("/issue-report") || this.props.router.location.pathname.includes("/complete-task") || (this.props.leftSideBarType === "condensed" && this.state.isMobile) ? '' : 'main-content'}>
                  {this.props.leftSideBarType === "condensed" && this.state.width <= 768 && <Header toggleMenuCallback={this.toggleMenuCallback} />}
                  {this.props.children}
                  {/* <Footer /> */}
                </div>
              </div>
              <Rightbar />
            </>
            :
            <LoadingDialog open={true} />
        }

      </React.Fragment>
    );
  }
}


const mapStatetoProps = state => {
  return {
    ...state.Layout,
    verifyAdmin: state.Login.verifyAdmin,
    error: (state?.Doctor?.error?.length !== 0 && state?.Doctor?.error) || (state?.Customer?.error?.length !== 0 && state?.Customer?.error) || (state?.Profile?.error?.length !== 0 && state?.Profile?.error) ||
      //  (state?.Dashboard?.error?.length !== 0 && state?.Dashboard?.error) ||
      (state?.Order?.error?.length !== 0 && state?.Order?.error) || (state?.Report?.error?.length !== 0 && state?.Report?.error) || (state?.General?.error?.length !== 0 && state?.General?.error) || (state?.Setting?.error?.length !== 0 && state?.Setting?.error),
  };
};
export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutTheme,
  changeLayoutWidth,
  verify_admin
})(withRouter(Layout));

